function mainSliderInit(){
  $('.js-main-slider').slick({
    fade: true,
    adaptiveHeight: true,
    arrows: false,
    dots: true,
    zindex: 100,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    swipe : false
  });
}

function otherErrorsSliderInit() {
    $('.similar-errors-slider').slick({
        fade: false,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        zindex: 100,
        autoplay: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 5000,
        swipe: true
    });
}


var ts;
$('.js-main-slider').bind('touchstart', function (e){
   ts = e.originalEvent.touches[0].clientX;
});

var vW = $(window).width() / 3

$('.js-main-slider').bind('touchend', function (e){
   var te = e.originalEvent.changedTouches[0].clientX;
   if(ts > te + vW){
      $(this).slick('slickNext');
   }else if(ts < te - vW){
      $(this).slick('slickPrev');
   }
});


var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
function specialService() {
   $('.js-service-slider').each(function () {
     var parent = $(this).parent();
       $(this).slick({
       infinite: true,
       speed: 800,
       slidesToShow: 2,
       centerMode: false,
       variableWidth: true,
       adaptiveHeight: false,
       arrows: true,
       dots: false,
       autoplay: true,
       autoplaySpeed: $(this).data('autoplay') || false,
       swipe: true,
       prevArrow: $('.slick-prev', parent),
       nextArrow: $('.slick-next', parent),
       responsive: [{
         breakpoint: 768,
         settings: {
             centerMode: true,
             dots: true,
         }
       }]
     });
       if (!isMobile) {
           parent.hover(function () {
               $(this).find('button').toggleClass('slick-arrow--active');
           })
       }
   });
 }

function reviewsSlider() {
  window.slider = $('.reviews-slider').not('.slick-initialized').each(function() {
    $(this).slick({
      fade: true,
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      zindex: 100,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 5000,
      swipe: true
    });
  });

  if (document.querySelector('.reviews-slider .testimonial__body')) {
    const reviewsBody = document.querySelectorAll('.reviews-slider .testimonial__body');

    function mutationHandler(slide) {
      let observer = new MutationObserver(function() {
        const openButton = slide.querySelector('.testimonial__body-open'),
              body = slide.querySelector('.testimonial__body');

        openButton.style.display = 'block';
        body.classList.remove('show');
        body.classList.add('hide');
      });

      observer.observe(slide, {
        attributeFilter: ['class'],
      })
    }

    reviewsBody.forEach(body => {
      if (body.scrollHeight !== body.clientHeight) {

        body.classList.add('hide');

        const openButton = document.createElement('span'),
              marginBottomBody = parseInt(window.getComputedStyle(body).marginBottom);

        openButton.classList.add('testimonial__body-open');
        openButton.textContent = 'Читать полностью'
        body.before(openButton);

        openButton.addEventListener('click', () => {
          const nextEl = openButton.nextElementSibling,
                sliderList = nextEl.closest('.slick-list.draggable');

          let bodyHeight = body.scrollHeight;

          if (document.body.clientWidth < 768) {
            bodyHeight = parseInt(sliderList.style.height) + (body.scrollHeight - body.clientHeight);
          }

          openButton.style.display = 'none';

          sliderList.style.height = bodyHeight + marginBottomBody + 'px';

          nextEl.classList.remove('hide');
          nextEl.classList.add('show');

          mutationHandler(body.closest('.reviews-slider__item'));
        })
      }
    })
  }

  var options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
  };

  // Включаем/выключаем слайдер, если он появляется/исчезает в пределах вьюпорта
  var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              var slider = entry.target;

              $(entry.target).slick('slickPlay');
          } else {
              $(entry.target).slick('slickPause');
          }
      })
  }, options);

  $('.reviews-slider').each(function(item) {
      observer.observe(this);
  });
}


